module.exports = "::ng-deep div.image-content {\n  margin: auto;\n  padding-bottom: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/competence/competence.component.scss
// module id = ./src/app/components/competence/competence.component.scss
// module chunks = main